import { createClient } from 'contentful';
import { createClient as createClientMgmt } from 'contentful-management';

/**
 * Get the pre scoped Preview client
 */
export const CF_PREVIEW_CLIENT = createClient({
  space: `${process.env.CONTENTFUL_SPACE_ID}`,
  accessToken: `${process.env.CONTENTFUL_PREVIEW_TOKEN}`,
  environment: `${process.env.CONTENTFUL_ENVIRONMENT}`,
  host: 'preview.contentful.com'
});

/**
 * Get the pre scoped Plain Client for contentful
 * THIS SHOULD NOT BE USED ON THE PUBLIC FRONT END.
 * THIS IS FOR BACKEND FUNCTIONALITY
 */
export const CF_MGMT_SCOPED_PLAIN_CLIENT = createClientMgmt(
  {
    // This is the management access token for this space.
    accessToken: `${process.env.CONTENTFUL_MGMT_ACCESS_TOKEN}`
  },
  {
    type: 'plain',
    defaults: {
      spaceId: `${process.env.CONTENTFUL_SPACE_ID}`,
      environmentId: `${process.env.CONTENTFUL_ENVIRONMENT}`
    }
  }
);

export const CF_STUDIO_DELIVERY_CLIENT = createClient({
  space: `${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}`,
  environment: `${process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}`,
  host: 'cdn.contentful.com',
  accessToken: `${process.env.NEXT_PUBLIC_CONTENTFUL_DELIVERY_TOKEN}`
});

export const CF_STUDIO_PREVIEW_CLIENT = createClient({
  space: `${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}`,
  accessToken: `${process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_TOKEN}`,
  environment: `${process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}`,
  host: 'preview.contentful.com'
});
